import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericDialogLoaderData } from './interfaces';

@Component({
    templateUrl: './generic-dialog-loader.component.html',
    standalone: false
})
export class GenericDialogLoaderComponent {

    constructor(
        public dialogRef: MatDialogRef<GenericDialogLoaderComponent, boolean>,
        @Inject(MAT_DIALOG_DATA) public data: GenericDialogLoaderData
    ) { }

}
